import { css } from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";

export const centerFormWrap = css`
  padding-left: 16px;
  padding-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;
